import { useMemo } from 'react'
import { daysHeader, isDayComplete, monthNames, toISODate } from '../lib/exercise'

function CalendarScreen({ plan, completion, viewMonth, setViewMonth, onOpenDay }) {
  const monthCells = useMemo(() => {
    const year = viewMonth.getFullYear()
    const month = viewMonth.getMonth()
    const firstDay = new Date(year, month, 1)
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const mondayStart = (firstDay.getDay() + 6) % 7

    const cells = []
    for (let i = 0; i < mondayStart; i += 1) {
      cells.push({ date: null, dayNumber: null })
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
      const current = new Date(year, month, day)
      cells.push({ date: toISODate(current), dayNumber: day })
    }

    return cells
  }, [viewMonth])

  const todayIso = toISODate(new Date())

  return (
    <main className="screen">
      <section className="dashboard-header">
        <p className="eyebrow">Tu plan</p>
        <h1>Calendario</h1>
      </section>

      <section className="calendar-panel">
        <header className="calendar-head">
          <button
            type="button"
            className="icon-button"
            onClick={() => setViewMonth((old) => new Date(old.getFullYear(), old.getMonth() - 1, 1))}
          >
            {'<'}
          </button>
          <h2>
            {monthNames[viewMonth.getMonth()]} {viewMonth.getFullYear()}
          </h2>
          <button
            type="button"
            className="icon-button"
            onClick={() => setViewMonth((old) => new Date(old.getFullYear(), old.getMonth() + 1, 1))}
          >
            {'>'}
          </button>
        </header>

        <div className="calendar-grid header">
          {daysHeader.map((day) => (
            <span key={day}>{day}</span>
          ))}
        </div>

        <div className="calendar-grid body">
          {monthCells.map((cell, index) => {
            const hasTraining = Boolean(cell.date && plan[cell.date])
            const complete = hasTraining && isDayComplete(plan[cell.date], cell.date, completion)

            return (
              <button
                key={`${cell.date ?? 'empty'}-${index}`}
                type="button"
                disabled={!cell.date}
                className={`day-cell ${complete ? 'completed-day' : ''} ${cell.date === todayIso ? 'today' : ''}`}
                onClick={() => cell.date && onOpenDay(cell.date)}
              >
                {cell.dayNumber ?? ''}
                {hasTraining && <small>{complete ? '✓' : 'Ver'}</small>}
              </button>
            )
          })}
        </div>
      </section>
    </main>
  )
}

export default CalendarScreen
